import { useEffect, useState } from 'react'
import { Redirect, Route, Switch, useParams } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'
import useMediaQuery from '@mui/material/useMediaQuery'

import { FlexContainer } from 'components/Flex'
import { useAccount } from 'hooks/useAccount'
import useAuth from 'lib/auth'
import { existDoc, getDoc } from 'lib/firestore'
import { Role } from 'utils/constant'

import LocationList from './LocationList'
import MemberList from './MemberList'
import AccountMenu from './Menu'
import Settings from './Settings'
import StockList from './StockList'

const NO_MATCH = 'NO_MATCH'

export default function Account() {
  const { user, isAdmin } = useAuth()
  const { accounts } = useAccount()
  const [account, setAccount] = useState(null)
  const { id } = useParams()
  const isXS = useMediaQuery(({ breakpoints }) => breakpoints.only('xs'))

  useEffect(() => {
    if (accounts === null) return

    const _account = accounts.find(x => x.id === id) || NO_MATCH

    if (_account !== NO_MATCH) {
      setAccount(_account)
    } else if (isAdmin) {
      existDoc(`accounts/${id}`).then(exist => {
        if (exist) {
          getDoc(`accounts/${id}`).then(doc =>
            setAccount({ ...doc, role: Role.OWNER.value, adminMode: true })
          )
        } else {
          setAccount(NO_MATCH)
        }
      })
    }
  }, [accounts, id, isAdmin])

  if (!user || !user.displayName || (accounts !== null && account === NO_MATCH)) {
    return <Redirect to="/" />
  }

  if (accounts === null || account?.id !== id) {
    return (
      <FlexContainer style={{ alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </FlexContainer>
    )
  }

  return (
    <FlexContainer row>
      {!isXS && <AccountMenu account={account} />}
      <Switch>
        <Route path="/accounts/:id/stocks">
          <StockList account={account} />
        </Route>
        <Route path="/accounts/:id/members">
          <MemberList account={account} />
        </Route>
        <Route path="/accounts/:id/locations">
          <LocationList account={account} />
        </Route>
        <Route path="/accounts/:id/settings">
          <Settings account={account} />
        </Route>
        <Redirect to={`/accounts/${account.id}/stocks`} />
      </Switch>
    </FlexContainer>
  )
}
